module.exports = __webpack_public_path__ + "img/logros.374185e8.svg";